module.exports = __webpack_public_path__ + "img/shop01.f54c2371.jpg";